/**
 * Endpoints #35-#38 — the scraper plugin surface (ARCHITECTURE §7.1, §4.1).
 *
 * A plugin declares flat `ConfigField[]`; the server derives its Zod schema from that list, so this
 * package carries the *shape* of a field but never a per-plugin schema. Secrets are write-only: a
 * read returns `masked`/`isSet`, and a write that omits a secret keeps the stored value (§10.3).
 */
import { z } from 'zod';
import { CONFIG_FIELD_TYPES, SCRAPER_KINDS } from '../enums.js';
/* ------------------------------------------------------------------ #36 PUT */
/**
 * Partial config write. Values arrive in their declared runtime type (the form coerces); a secret
 * left untouched is simply omitted and keeps its stored value.
 */
export const ScraperConfigUpdateBodySchema = z.strictObject({
    config: z.record(z.string().min(1).max(100), z.union([z.string(), z.number(), z.boolean()])),
});
/* --------------------------------------------------------------- #38 active */
export const ActiveScraperUpdateBodySchema = z.strictObject({
    kind: z.enum(SCRAPER_KINDS),
    pluginId: z.string().min(1).max(100).nullable(),
});
/* ------------------------------------------------------------------ helpers */
export const CONFIG_FIELD_TYPE_VALUES = CONFIG_FIELD_TYPES;
//# sourceMappingURL=scrapers.js.map